import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SideCollapsible.scss';

const SideCollapsible = ({
  children,
  isOpen,
  labelledBy,
}) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div
      className={clsx('position-absolute hidden-sm-down', styles.collapsibleOverlay)}
      aria-labelledby={labelledBy}
    >
      {children}
    </div>
  );
};

SideCollapsible.propTypes = {
  children: PropTypes.node.isRequired,
  labelledBy: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export { SideCollapsible as TestableSideCollapsible };

export default SideCollapsible;
